import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import './style.scss'
import { Container } from 'react-bootstrap'
import HomeSecondTitle from '../../../homeTitle/HomeSecondTitle'
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from 'swiper';
import { fetchAnnouncementsData } from '../../../../redux/action/homePage/announcements/homeAnnouncements'
import { useDispatch, useSelector } from 'react-redux'
import MainLoading from '../../../../utils/MainLoading'
import renderHTML from 'react-render-html'
import './style.scss'
import { useTranslation } from 'react-i18next'
SwiperCore.use([Pagination]);

const Announcements = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch()
  const announcements_data = useSelector(state => state.announcements_data)
  
  useEffect(() => {
    if(!announcements_data.announcements.data) {
      dispatch(fetchAnnouncementsData())
    }
  }, [])

    return (
        <Container>
          {announcements_data.loading ?
            <MainLoading />
          :
            announcements_data.announcements.data &&
              announcements_data.announcements.data.length ?
              <div className='homepage_announcements_container mb-5'>
                  <HomeSecondTitle link="/announcements" title={t("announcements")} />
                  <div className='homepage_announcements'>
                    <Swiper 
                      spaceBetween={20} 
                      pagination={{ "clickable": true }}
                      breakpoints={{
                        640: {
                          width: 640,
                          slidesPerView: 1,
                        },
                        900: {
                          width: 900,
                          slidesPerView: 2,
                        },
                        990: {
                          width: 990,
                          slidesPerView: 3,
                        },
                      }}
                      className="largeSwiper">
                        {announcements_data.announcements.data.map(item => (
                          <SwiperSlide key={item.id}>
                            <div className='homeannounceitem'>
                              <div className='home_announcement_item_content'>
                                <h6>{item.title}</h6>
                                <div className='home_announcement_item_description'>{renderHTML(item.description)}</div>
                                <div className='d-flex justify-content-end'>
                                  <Link className='btn purple-btn btn-sm px-4' to={`announcement/${item.id}`}>{t("view")}</Link>
                                </div>
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                    </Swiper>
                  </div>
              </div>
            :
              ''
          }
        </Container>
    )
}

export default Announcements
